import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Table2 } from "lucide-react";
import { api } from "@/lib/api";
import { colors } from "@/theme";
import { SectionTitle, Spinner, EmptyState } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { toast } from "sonner";

export default function Shortlists() {
  const [lists, setLists] = useState(null);
  const isMobile = useIsMobile();

  const load = () => api("/shortlists").then(setLists).catch(() => setLists([]));
  useEffect(() => { load(); }, []);

  const create = async () => {
    const name = window.prompt("Name your Nest Table (e.g. Wedding Registry)");
    if (!name) return;
    try { await api("/shortlists", { method: "POST", body: { name } }); toast.success("Nest Table created"); load(); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px", maxWidth: 900 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
        <SectionTitle eyebrow="Shareable Registries" title="Nest Tables" subtitle="Curate wishlists and share them for gifting." />
        <button data-testid="create-shortlist" className="btn-brand" onClick={create}><Plus size={15} style={{ verticalAlign: "middle", marginRight: 6 }} />New Table</button>
      </div>
      {lists === null ? <Spinner /> : lists.length === 0 ? (
        <EmptyState title="No Nest Tables yet" message="Create a shareable registry for weddings, housewarmings & more." action={<button className="btn-primary" onClick={create}>Create your first</button>} />
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", gap: 18, marginTop: 8 }}>
          {lists.map((sl) => (
            <Link key={sl.id} to={`/shortlist/${sl.id}`} data-testid={`shortlist-${sl.id}`} className="card-hover" style={{ textDecoration: "none", color: colors.onSurface, border: `1px solid ${colors.border}`, borderRadius: 12, overflow: "hidden" }}>
              <div style={{ display: "flex", height: 120 }}>
                {(sl.products || []).slice(0, 3).map((p, i) => (
                  <div key={i} style={{ flex: 1, background: colors.surfaceSecondary }}>
                    {p.images?.[0] && <img src={p.images[0]} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
                  </div>
                ))}
                {(!sl.products || sl.products.length === 0) && (
                  <div style={{ flex: 1, background: colors.surfaceSecondary, display: "flex", alignItems: "center", justifyContent: "center" }}><Table2 size={28} color={colors.mutedText} /></div>
                )}
              </div>
              <div style={{ padding: 16 }}>
                <div className="font-display" style={{ fontSize: 20, fontWeight: 700 }}>{sl.name}</div>
                <div className="font-body" style={{ fontSize: 13, color: colors.mutedText, marginTop: 2 }}>{sl.count} item{sl.count !== 1 ? "s" : ""}{sl.occasion ? ` · ${sl.occasion}` : ""}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
